import { useTranslation } from 'react-i18next';

import { getPalletLabel } from 'utils/functions';

import styles from './PalletAmountSummary.module.css';

type PalletAmountSummaryProps = {
   palletsSum: number;
};

const PalletAmountSummary = ({ palletsSum }: PalletAmountSummaryProps) => {
   const { t } = useTranslation();

   return (
      <div className={styles.summary}>
         <h3>{t('palletAmountSummary.title')}</h3>
         <span>
            <span className={styles.summaryTextLarge}>{palletsSum}</span>
            {` ${getPalletLabel(palletsSum)}`}
         </span>
      </div>
   );
};

export default PalletAmountSummary;
